import { faker } from '@faker-js/faker';
import {
    areaChartFake,
    barChartFake,
    doublePieChartFake,
    imageByBase64,
    imageByUrl,
    lineChartFake,
    pieChartFake,
    radarChartFake,
    stakedBarChartFake,
} from './chart.faker';

export const generateAgentInteractionFaker = () => ({
    conversation_id: faker.datatype.uuid(),
    agent_id: 'agent001',
    query: faker.lorem.words(3),
    agent_response: faker.lorem.sentences(2),
    tool_usage: {
        total_tools_used: 0,
        tools_sequence: [],
        detailed_usage: [],
    },
    attachments: [
        lineChartFake,
        pieChartFake,
        doublePieChartFake,
        barChartFake,
        stakedBarChartFake,
        areaChartFake,
        radarChartFake,
        imageByBase64,
        imageByUrl,
    ],
    metadata: {},
    usage_metadata: {},
});
